// @flow
import * as React from 'react';
import Utilities from '../../utils/Utilities';
import {
  Menu,
  MenuDivider,
  MenuItem,
  Popover,
  PopoverInteractionKind,
  Position,
  AnchorButton,
  Icon,
} from '@blueprintjs/core';

export default ({ controller, action, userIsAccountOwner, isManager, showGoal }) => {
  return (
    <Popover
      portalContainer={document.body}
      position={Position.RIGHT}
      boundary="viewport"
      interactionKind={PopoverInteractionKind.HOVER}
      popoverClassName="sidebar-submenu-popover"
      content={
        <Menu className="sidebar-submenu-menu">
          <li className="bp3-menu-header">
            <h6 className="bp3-heading">Reports</h6>
          </li>
          <MenuDivider />

          <MenuItem
            text="Overview"
            icon={<Icon icon="panel-table" iconSize={14} />}
            onClick={() => Utilities.navigate('/reports')}
            href="/reports"
          />
          {showGoal && userIsAccountOwner && (
            <MenuItem
              text="Goal Cycles"
              icon={<Icon icon="chart" iconSize={14} />}
              onClick={() => Utilities.navigate('/reports/goal_cycle')}
              href="/reports/goal_cycle"
            />
          )}

{/* {showGoal && userIsAccountOwner && (
            <MenuItem
              text="360 Feedback"
              icon={<Icon icon="grouped-bar-chart" iconSize={14} />}
              onClick={() => Utilities.navigate('/360_feedback/reports')}
              href="/360_feedback/reports"
            />
          )} */}
           {showGoal && userIsAccountOwner ? (
            <MenuItem
              text="360 Feedback"
              icon={<Icon icon="grouped-bar-chart" iconSize={14} />}
              onClick={() => Utilities.navigate('/360_feedback/reports')}
              href="/360_feedback/reports"
            />
          ):
          (
            <MenuItem
            text="360 Feedback"
            icon={<Icon icon="grouped-bar-chart" iconSize={14} />}
            onClick={() => Utilities.navigate('/360_feedback/report/employee')}
            href="/360_feedback/report/employee"
          />
          )} 
          {isManager && (
            <MenuItem
              text="Team Review"
              icon={<Icon icon="people" iconSize={14} />}
              onClick={() => Utilities.navigate("/reports/team_performance")}
              href="/reports/team_performance"
            />
          )}
          {showGoal && userIsAccountOwner && (
            <MenuItem
              text="Check-ins"
              icon={<Icon icon="timeline-events" iconSize={14} />}
              onClick={() => Utilities.navigate('/reports/check_ins')}
              href="/reports/check_ins"
            />
          )}
        </Menu>
      }
    >
      <AnchorButton
        className="bp3-minimal bp3-sidebar-button"
        active={
          (controller && controller === 'reports') ||
          (action &&
            (action === 'reports' ||
              action === 'goal_cycle_report' ||
              action === 'check_ins_report' ||
              action === 'performance_tabs' ||
              action === 'review_360_report' ||
              action === 'review_360_report_user'))
        }
        text={window.I18n ? window.I18n.t('js.reports') : 'Reports'}
        href="/reports"
        onClick={() => Utilities.navigate('/reports')}
        icon={<Icon icon="panel-table" iconSize={14} />}
        rightIcon="chevron-right"
      />
    </Popover>
  );
};